

<p-inputgroup>
    <input pInputText placeholder="Nome etichetta" [ngModel]="shortDescription()" (ngModelChange)="shortDescription.set($event)" id="etiquette-name" />
    <p-inputgroup-addon>
        <p-button icon="pi pi-check" severity="primary" (click)="onSave.emit(buildEtiquette())" [disabled]="!isValid()"/>
    </p-inputgroup-addon>
    @if(etiquette() && etiquette().etiquetteId){
    <p-inputgroup-addon>
        <p-button icon="pi pi-trash" severity="danger" (click)="onDelete.emit(buildEtiquette())" [disabled]="!isValid()"/>
    </p-inputgroup-addon>
    }
</p-inputgroup>
 @if(!isValid()){
    <small class="p-error">Minimo 3, massimo 50 caratteri. </small>
}
